import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import ReactImageMagnify from 'react-image-magnify';
import MDBox from "dashboard/components/MDBox";
import MDAvatar from "dashboard/components/MDAvatar";
import { Icon, Divider, IconButton, Card } from "@mui/material";

const sliderVariant = {
    initial : direction =>({
      x : direction < 0 ? "-100%" : "100%",
      opacity : 0
    }),
    animate : {
      x : 0,
      opacity : 1
    },
    exit : direction =>({
      x: direction > 0 ? "-100%" : "100%",
      opacity : 0
    }),
    transition : {
      type : "tween",
      ease : "easeInOut"
    }
  }
  
  const itemStyle = {
    position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      alignItems: 'center',
      justifyContent: 'center'
  }
  
  
  const wrap = (index, total) => {
    if(index < 0){
      return total - 1
    }
    if(index >= total){
      return 0
    }
    return index
  }

const MDCarousel = ({ items, zoom, color, thumbnail }) => {

  const [[imgIndex,direction], setImgIndex] = useState([0,0]);
  const carouselPrevNext = direct =>{
    const newIndex = wrap(imgIndex + direct, items.length);
    setImgIndex([newIndex, direct]);
  }
  const carouselPagination = index => index > imgIndex ? setImgIndex([index,1]) : setImgIndex([index,-1]);

  const carousel = items.map( photo =>(
    zoom ? (<ReactImageMagnify {...{
        smallImage: {
            alt: photo.name,
            isFluidWidth: true,
            src: `${process.env.REACT_APP_PUBLIC_URL}/img/product/${photo.path}`
        },
        largeImage: {
            src: `${process.env.REACT_APP_PUBLIC_URL}/img/product/${photo.path}`,
            width: 1200,
            height: 1800
        },
        imageStyle : {
          borderRadius : 12,
          border : "2px solid #eee",
          height:"100%"
        },
        isHintEnabled:true,
        enlargedImagePosition : "over"
      }} />) : (
        <MDBox 
            component="image"
            src={`${process.env.REACT_APP_PUBLIC_URL}/img/product/${photo.path}`}
            alt={photo.name}
            sx={{height:"100%"}}
        />
      )
  ))
  const currentCarousel = carousel[imgIndex]
  return (
    <MDBox component="div" sx={{ height:"100%", minHeight:"30vh"}}>
        <Card
            sx={{
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
            height:"calc(100% - 70px)",
            position:"relative", overflow:"hidden"
            }}
          >
            <AnimatePresence initial="false"  custom={direction}>
            {items && <motion.div
                initial="initial"
                variants={sliderVariant}
                exit="exit"
                animate="animate"
                transition="transition"
                key={imgIndex}
                style={itemStyle}
                custom={direction}
                >
                {currentCarousel}
                </motion.div>}
            </AnimatePresence>
        </Card>
        <Divider/>
        <MDBox display="flex" justifyContent="center" alignItems="center">
        <IconButton
            sx={{backgroundColor: color}}
            size="medium"
            onClick={()=>carouselPrevNext(-1)}
        >
            <Icon>chevron_left</Icon>
        </IconButton>
        <MDBox mx={2} display="inline-flex" justifyContent="space-around" alignItems="center">
        {items && items.map( (photo,index) =>(
            <IconButton
            key={`crrent-${photo.name}`}
            size="medium"
            onClick={()=>carouselPagination(index)}
            >
            {thumbnail ? <MDAvatar shadow="sm" variant="rounded" size="lg" src={`${process.env.REACT_APP_PUBLIC_URL}/img/product/${photo.path}`} alt={photo.name}/>
             : <Icon >radio_button_unchecked</Icon>}
            </IconButton>
        ))}
        </MDBox>
        <IconButton
            sx={{backgroundColor: color}}
            size="medium"
            onClick={()=>carouselPrevNext(1)}
        >
            <Icon>chevron_right</Icon>
        </IconButton>
        </MDBox>
  </MDBox>
  )
}

export default MDCarousel